import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import DisabledCell from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/DisabledCell'
import RestDayCell from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/RestDayCell'
import BankHolidayItem from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/ShiftCell/BankHolidayItem'
import LeaveItem from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/ShiftCell/LeaveItem'
import WrapperCell from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/Cells/WrapperCell'
import type { ColumnsType } from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/utils/buildColumns'
import { getResources } from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/utils/getResources'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import type { ShiftsRow } from 'modules/shift_management/lib/types'

import ShiftsGrid from './ShiftsGrid'

export interface Props {
  shiftsRow: ShiftsRow
  columns: ColumnsType
  contractVersions: ContractVersions
}

const DailyRow = ({ shiftsRow, columns, contractVersions }: Props) => {
  const [{ view }] = useSchedule()
  const date = view.firstDay
  const { employee, leaves, holiday, restDay } = getResources(shiftsRow, date, view)

  const nonWorkableLeaves = leaves.some((leave) => !leave.workable)
  const workable = !nonWorkableLeaves && !restDay
  const showShiftCells = workable || shiftsRow.hasShifts

  if (shiftsRow.isDisabled(view, date)) {
    return (
      <WrapperCell key={shiftsRow.id} minWidth="full">
        <DisabledCell />
      </WrapperCell>
    )
  }

  if (!employee) return null

  return (
    <WrapperCell key={shiftsRow.id} minWidth="full">
      {!!holiday && (
        <Box padding="s4">
          <BankHolidayItem holiday={holiday} />
        </Box>
      )}
      {!!leaves &&
        leaves.map((leave) => (
          <Box key={leave.id} padding="s4">
            <LeaveItem
              leave={leave}
              shiftsRow={shiftsRow}
              date={date}
              contractVersions={contractVersions}
              employee={employee}
            />
          </Box>
        ))}
      {!!restDay && (
        <Box padding="s4">
          <RestDayCell employee={employee} restDay={restDay} />
        </Box>
      )}
      {showShiftCells && (
        <ShiftsGrid
          shiftsRow={shiftsRow}
          employee={employee}
          view={view}
          columns={columns}
          contractVersions={contractVersions}
        />
      )}
    </WrapperCell>
  )
}

export default observer(DailyRow)
